var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-menu__button",on:{"click":_vm.toggleMenu}},[_c('span',{staticClass:"mobile-menu__line"}),_c('span',{staticClass:"mobile-menu__line"}),_c('span',{staticClass:"mobile-menu__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }